import React, { useState, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import _ from 'lodash'

import { Button, Input, Select } from '@leasequery/lq.react-component-library'
import { PaymentContext } from '../../context/PaymentContext'
import { getRateImplicit } from '../../utils/FetchRequests'
import industryOptions from './industryOptions'
import postSubmit from '../../submit-hubspot/apiPost'

export default function SubmitRitForm({ submitForm }) {
	const history = useHistory()
	const [errorMessage, setErrorMessage] = useState('')
	const [inputForm, setInputForm] = useState({
		firstName: '',
		lastName: '',
		email: '',
		phone: '',
		industry: '',
		emailArray: [''],
	})

	const ritDataString = sessionStorage.getItem('rit-questions')
	const ritDataObj = JSON.parse(ritDataString)

	const leaseName = ritDataObj['1']['answer']
	const startDate = ritDataObj['2']['answer']
	const endDate = ritDataObj['2']['subAnswer']
	const firstPaymentDate = ritDataObj['4']['answer'][0]['firstPaymentDate']
	const fairValue = ritDataObj['3']['answer']
	const expectedResidualValue = ritDataObj['5']['answer']
	const paymentPeriods = Number(
		ritDataObj['4']['answer'][0]['paymentFrequency']
	)
	const numPaymentPeriods = ritDataObj['4']['answer'].length
	const [payments] = useContext(PaymentContext)

	let context = {
		pageUri: 'https://tools.leasequery.com/rate-implicit-calculator',
		pageName: 'Rate Implicit Calculator',
	}
	let identifier = 'rit'

	let guaranteedResidualValue = 0

	const userResponses = {
		submittedAt: '',
		fields: [
			{
				name: 'firstname',
				value: inputForm.firstName,
			},
			{
				name: 'lastname',
				value: inputForm.lastName,
			},
			{
				name: 'industry',
				value: inputForm.industry.value,
			},
			{
				name: 'phone',
				value: inputForm.phone,
			},
			{
				name: 'email',
				value: inputForm.email,
			},
			{
				name: 'additional_emails',
				value: inputForm.emailArray.toString(),
			},
		],
		context,
	}

	function paymentAmounts(paymentPeriods) {
		let amounts = []
		isGRV()

		payments.forEach((payment) => {
			let grouped = _.groupBy(payment, (amount) => amount.year)
			Object.values(grouped).forEach((payment) => {
				let total = 0
				if (paymentPeriods === 3) {
					if (numPaymentPeriods === 1) {
						payment.forEach((amount) => {
							total += amount.amount
						})
						amounts.push(total)
					} else {
						payment.forEach((amount) => {
							if (amount.amount !== 0) {
								amounts.push(amount.amount)
							}
						})
					}
				} else if (paymentPeriods === 1) {
					payment.forEach((amount) => {
						amounts.push(amount.amount)
					})
				}
			})
		})

		if (paymentAtBeginningOrEnd() === false && paymentPeriods === 1) {
			if (amounts[0] === 0) {
				amounts.shift()
			}
		}

		return amounts
	}

	function paymentAtBeginningOrEnd() {
		let date = firstPaymentDate
		let day = date.slice(3, 5)
		if (day === '01') {
			return true
		} else {
			return false
		}
	}

	function isGRV() {
		// iterate through all payment groups and look for payments that occur on the lease end date, which is when Guaranteed Residual Value payments will be scheduled
		payments.forEach((payment, index) => {
			let lastPayment = payment[payment.length - 1]
			if (endDate === lastPayment.formattedDate && lastPayment.amount !== 0) {
				// when a payment group is found that has a payment occuring on the last day of the lease, save the last payment in that particular group and save the index of that payment group
				let lastPayment = payment[payment.length - 1]
				let grvPayment = index
				payment.forEach((p, index) => {
					// iterate through the payment group that has a payment on the last day of the lease, make sure that all payments are zero except for the last payment in the group
					if (index !== payment.length - 1 && p.amount !== 0) {
						return
					} else {
						// verify that the last payment is the only payment in the group by checking the payment value before it.
						// monthly and yearly payments will have a payment value before the last payment and will therefore not be GRVs.
						// GRVs have only 1 payment in the entire group, scheduled on the last day of the lease.
						if (
							index === payment.length - 1 &&
							payment[index - 1].amount === 0
						) {
							// remove the GRV payment group from the rest of the payment groups otherwise it will throw off the rate calculation
							payments.splice(grvPayment, 1)
							// set the Guaranteed Residual Value to be equal to the last (only) payment in the GRV payment group
							guaranteedResidualValue = lastPayment.amount
						} else {
							return
						}
					}
				})
			}
		})
	}

	function validateForm() {
		const email = validateEmail(inputForm.email)
		const phone = validatePhone(inputForm.phone)
		const errors = Object.keys(inputForm).filter(
			(key) => key !== 'emailArray' && key !== 'phone' && inputForm[key] === ''
		)
		let emailArray = true
		let filteredArray

		if (inputForm.emailArray.length > 0) {
			filteredArray = inputForm.emailArray.filter((email) => email !== '')
			const validateArray = filteredArray.map((email) => validateEmail(email))
			if (validateArray.includes(false)) {
				emailArray = false
			}
		}

		if (email && phone && emailArray && errors.length === 0) {
			setErrorMessage('')

			let jsonObjRate = {
				leasePayments: paymentAmounts(paymentPeriods),
				fairValueOfUnderlyingAsset: fairValue,
				expectedInvestmentCreditToBeRetainedByLessor: 0,
				expectedResidualValueAtEndOfTerm: parseInt(expectedResidualValue),
				guaranteedResidualValueAtEndOfTerm: guaranteedResidualValue,
				deferredLessorInitialDirectCosts: 0,
				paymentIsAtBeginningOfPeriod: paymentAtBeginningOrEnd(),
				periodsInYear: paymentPeriods === 3 ? 1 : 12,
			}

			postSubmit(userResponses, identifier).then((hubSpotResponse) => {
				if (
					hubSpotResponse.errors &&
					hubSpotResponse.errors[0].errorType === 'BLOCKED_EMAIL'
				) {
					setErrorMessage('Submissions from this email address are not allowed')
				} else {
					getRateImplicit(jsonObjRate).then((data) => {
						submitForm(
							hubSpotResponse.redirectUri,
							inputForm.email,
							inputForm.firstName,
							leaseName,
							startDate,
							endDate,
							fairValue,
							expectedResidualValue,
							data,
							payments
						)
						sessionStorage.clear()
					})
				}
			})
		} else if (!phone) {
			setErrorMessage(`Please enter a valid phone number`)
		} else {
			setErrorMessage(`Please fill out all fields in order to submit`)
		}
	}

	function onChange(name, value) {
		setInputForm({ ...inputForm, [name]: value })
	}

	function navigateBack() {
		history.goBack()
	}

	function validateEmail(email) {
		// eslint-disable-next-line
		const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		return re.test(email)
	}

	function validatePhone(phone) {
		// (123) 456-7890, (123)456-7890, 123,456,7890, 123.456.7890, 1234567890, +3163633634, 075-63646725
		// eslint-disable-next-line
		const re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
		if (phone === '' || phone.match(re)) {
			return true
		} else {
			return false
		}
	}

	return (
		<div className='form-Container'>
			<Input
				name='firstName'
				value={inputForm.firstName}
				onChange={(e) => onChange('firstName', e.target.value)}
				disabled={false}
				label='First Name'
				type='text'
				className='form-Input'
				required={true}
			/>

			<Input
				name='lastName'
				value={inputForm.lastName}
				onChange={(e) => onChange('lastName', e.target.value)}
				disabled={false}
				label='Last Name'
				type='text'
				className='form-Input'
				required={true}
			/>

			<Input
				name='email'
				value={inputForm.email}
				onChange={(e) => onChange('email', e.target.value)}
				disabled={false}
				label='Work Email'
				type='text'
				className='form-Input'
				required={true}
			/>

			<Input
				name='phone'
				value={inputForm.phone}
				onChange={(e) => onChange('phone', e.target.value)}
				disabled={false}
				label='Phone Number'
				type='text'
				className='form-Input'
			/>

			<Select
				name='industry'
				options={industryOptions}
				value={inputForm.industry}
				onChange={(e) => onChange('industry', e)}
				disabled={false}
				label='Company Industry'
				className='form-Input'
				required={true}
			/>

			<div className='text-Privacy'>
				Your information will be treated in accordance with our{' '}
				<a href='https://leasequery.com/privacy-statement/'>
					privacy statement.
				</a>
			</div>

			<div className='errorMessage-Container'>{errorMessage}</div>

			<div className='form-Button-Container'>
				<Button
					buttonType='secondary'
					className='form-Button'
					onClick={() => navigateBack()}
				>
					Back
				</Button>

				<Button
					buttonType='primary'
					className={
						identifier === 'rit'
							? 'form-Submit-Button form-Submit-Button-orange'
							: 'form-Submit-Button'
					}
					onClick={() => validateForm()}
				>
					Send Results
				</Button>
			</div>
		</div>
	)
}
